export const UPGRADE_URL = "https://www.metabase.com/upgrade";
